// Using /max metadata so getType() can distinguish mobile from landline.
// The /min build strips type info and would make isMobile always false,
// which breaks the registration UX (live preview + landline warning).
import { parsePhoneNumberFromString } from 'libphonenumber-js/max'

export interface ParsedPhone {
  e164: string
  country: string
  isMobile: boolean
  type: string
}

// Phone-allowed characters: digits, +, (, ), -, space, period.
// Anything else (letters, @, slash, etc.) means input is NOT a phone
// and libphonenumber's permissive extraction would silently sanitize it.
const PHONE_INPUT_PATTERN = /^[\d+()\-\s.]+$/

export function parsePhone(input: string, defaultCountry: 'UA' = 'UA'): ParsedPhone | null {
  if (!input || typeof input !== 'string') return null
  const trimmed = input.trim()
  if (!PHONE_INPUT_PATTERN.test(trimmed)) return null
  const parsed = parsePhoneNumberFromString(trimmed, defaultCountry)
  if (!parsed || !parsed.isValid()) return null
  const type = parsed.getType() ?? 'UNKNOWN'
  const isMobile = type === 'MOBILE' || type === 'FIXED_LINE_OR_MOBILE'
  return {
    e164: parsed.format('E.164'),
    country: parsed.country ?? defaultCountry,
    isMobile,
    type,
  }
}
